<template>
  <div class="list-container">
    <div >
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">公司名称</span>
            <el-input
              v-model="listQuery.companyName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">业务编号</span>
            <el-input
                v-model="listQuery.businessNo"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
          <div class="filter-box">
            <span class="label">业务名称</span>
            <el-input
                v-model="listQuery.businessName"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
          <div class="filter-box">
            <span class="label">型号</span>
            <el-input
                v-model="listQuery.businessModel"
                style="width: 200px"
                :size="t('table.btnSize')"
                class="filter-item"
                clearable
                @keyup.enter="handleFilter"
              />
          </div>
          <div class="filter-box">
            <span class="label">业务代表</span>
            <el-select :filterable="true" v-model="listQuery.salesManId" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleSalesManFocus" @change="handleFilter">
              <el-option
                v-for="item in salesManOption"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">付款状态</span>
            <el-select :filterable="true" v-model="listQuery.status" class="filter-item" placeholder="" @change="handleFilter" clearable :size="t('table.btnSize')">
              <el-option
                v-for="item in statusOption"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">登记时间</span>
            <!-- <el-date-picker
              v-model="listQuery.time"
              type="daterange"
              range-separator="～"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            /> -->
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">付款时间</span>
            <!-- <el-date-picker
              v-model="listQuery.payTime"
              type="daterange"
              range-separator="～"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            /> -->
            <el-date-picker
              v-model="listQuery.payStartTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.payEndTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
           <el-button
            v-permission="{ pkey: `${permissionName}_PAYOK` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('batch-payOk')"
          >
            批量确认
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{ isFilterCollapse ? '展开' : '收起' }}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
                <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
                <i class="icon-tubiao-28 iconfont"/>
          </span>
        </div>
      </div>
      <TableList
        ref="tableDataRef"
        v-loading="listLoading"
        :dataList="list"
        :columnAllData="columnAllData"
        :tableName="TableName"
        :permissionName="permissionName"
        :tableRowClassName="tableRowClassName"
        :isShowPagination="false"
        :showSelection="true"
        :showSummary="true"
        :handleDefaultWidth="100"
        @command-change="handleCommand"
      >
        <template v-slot:operation-action="scope">
          <el-link
            v-permission="{ pkey: `${permissionName}_PAYOK` }"
            href="javascript:void(0);"
            v-if="scope.row.status !== '完成'"
            class="mr-10"
            type="primary"
            @click="handleCommand('PAYOK', scope.row)"
          >
            支付确认
          </el-link>
        </template>
      </TableList>
      <el-pagination
        class="mt-20"
        v-show="total > 0"
        :total="total"
        v-model:currentPage="listQuery.page"
        :page-size="listQuery.size"
        :page-sizes="pageSizes"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next"
      />
    </div>
    <el-dialog
        v-model="dialogFormVisible"
        v-if="dialogFormVisible"
        title="支付确认"
        width="80%"
      >
      <div class="form-title mb-10">
        <span class="label blue" >业</span>
        <span class="left">业务信息</span>
      </div>
       <MiniBusinessList :businessList="selectionRowList" @table-select="handleTableSelect">
        <template v-slot:before>
          <el-table-column prop="businessNo" label="业务编号" width="100" show-overflow-tooltip/>
          <el-table-column prop="fee" label="总费用" show-overflow-tooltip width="100" align="right">
            <template #default="{ row }">
              {{ $currency(row.fee) }}
            </template>
          </el-table-column>
           <el-table-column prop="feeType" label="费用类型" show-overflow-tooltip width="100"/>
           <el-table-column prop="approveUser" label="审批人" show-overflow-tooltip width="100"/>
           <el-table-column prop="approveTime" label="审批时间" show-overflow-tooltip width="100"/>

          <el-table-column prop="accountAlias" label="收款账户" show-overflow-tooltip width="100"/>
          <el-table-column prop="customerCompanyContact.name" label="收款人" show-overflow-tooltip width="100">
            <template #default="{ row }">
              {{ row?.customerCompanyContact?.name || '' }}
            </template>
          </el-table-column>

          <el-table-column prop="invoiceStatus" label="开票信息" show-overflow-tooltip width="90">
            <template #default="{ row }">
              {{ row.invoice ? '未申请开票' : ' 已申请开票' }}
            </template>
          </el-table-column>
          <el-table-column prop="mark" label="申请备注" show-overflow-tooltip width="100"/>
        </template>
        <template v-slot:after>
          <el-table-column prop="amount" label="数量" width="80"/>
          <el-table-column prop="businessName" label="业务名称" width="100" show-overflow-tooltip/>
          <el-table-column prop="businessBrand" label="业务品牌" width="100" show-overflow-tooltip/>
          <el-table-column prop="businessModel" label="型号" show-overflow-tooltip/>
          <el-table-column prop="businessUnit" label="单位"/>
          <el-table-column prop="businessSerial" label="序列号" show-overflow-tooltip/>
          <el-table-column prop="outCost" label="市场费成本" width="120" align="right">
            <template #default="{ row }">
              {{ $currency(row.business.marketCost)}}
            </template>
          </el-table-column>
        </template>
      </MiniBusinessList>
      <!-- <div v-if="activeRow.business.orderTaxRate">
        <div class="form-title mb-10">
          <span class="label blue" >订</span>
          <span class="left">订单信息</span>
        </div>
        <OrderFeeDesc :detail="activeRow.business" >
          <template v-slot:after>
            <el-descriptions-item label="开票信息：">{{activeRow.invoice?'未申请开票':' 已申请开票'}}</el-descriptions-item>
          </template>
        </OrderFeeDesc>
      </div>
      <div class="form-title mb-10 mt-30">
        <span class="label yellow" >客</span>
        <span class="left">客户信息</span>
      </div>
      <el-descriptions >
        <el-descriptions-item label="费用信息：">{{activeRow.fee}}</el-descriptions-item>
        <el-descriptions-item label="费用类型：">{{activeRow.feeType}}</el-descriptions-item>
        <el-descriptions-item label="审批人：">{{activeRow.approveUser}}</el-descriptions-item>
        <el-descriptions-item label="审批时间：">{{activeRow.approveTime}}</el-descriptions-item>
      </el-descriptions>
      <div class="form-title mb-10 mt-30">
        <span class="label yellow" >账</span>
        <span class="left">账号信息</span>
      </div>
      <AccountPreview :account="activeRow.account" v-if="activeRow.account" /> -->
      <div class="form-title mt-30 mb-10">
        <span class="label green" >支</span>
        <span class="left">支付确认</span>
      </div>
      <el-form
        ref="dataForm"
        :model="formData"
        :rules="rules"
        label-position="top"
        label-width="100px"
        class="mb-20"
        >
          <div class="underlineForm">
            <el-form-item label="付款账户" prop="paymentAccountId">
              <el-select :filterable="true" v-model="formData.paymentAccountId" class="filter-item" placeholder="输入关键字搜索" clearable>
                <el-option
                  v-for="item in accountOption"
                  :key="item.id"
                  :label="item.mark"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="付款时间" prop="paymentTime">
              <el-date-picker
                v-model="formData.paymentTime"
                type="date"
                placeholder=" "
                format="YYYY-MM-DD"
                value-format="YYYY-MM-DD"
                :size="t('table.btnSize')"
              />
            </el-form-item>
            <el-form-item label="付款备注" prop="paymentMark" class="fullWidth">
              <el-input
                v-model="formData.paymentMark"
                placeholder=" "
                type="textarea"
              />
            </el-form-item>
          </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogFormVisible = false" type="danger">取消</el-button>
          <el-button type="primary" @click="handleSubmit">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, ref, unref } from 'vue'
import { cloneDeep } from 'lodash'
import { ElMessage, ElForm } from 'element-plus'

import { paymentConfirm } from '@/apis/BusinessMarketFee'
import { getPageList } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'
import { CostModel, ArrayRowsItem } from '@/model/Index'

// import FormComponent from './Form.vue'
import TableList from '@/components/common/TableList.vue'
import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from '@/views/business/outsourceCompany/accountInfo/FieldFrom'
// import AccountPreview from '@/views/business/outsourceCompany/AccountPreview/Index.vue'
// import OrderFeeDesc from '@/views/order/OrderFeeDesc.vue'
import { TableField } from './FieldTable'
import { useI18n } from 'vue-i18n'
import mixin from '@/mixins'
import { Today, pageVo, pageSizes, defaultDate } from '@/utils/index'
import MiniBusinessList from '@/views/business/businessList/MiniBusinessList.vue'

export default defineComponent({
  name: 'Marketfeeuser',
  components: {
    // FormComponent,
    TableList,
    // AccountPreview,
    // OrderFeeDesc,
    MiniBusinessList
  },
  setup() {
    const { t } = useI18n()
    const tableDataRef = ref(null)
    const dataForm = ref(ElForm)
    const dataMap = reactive({
      TableName: TableName.TABLE_MARKETFEEUSER,
      permissionName: permissionName.MARKETFEEUSER,
      initFormData: cloneDeep(FromFieldData),
      originFromFieldData: cloneDeep(FromFieldData),
      targetFromFieldData: cloneDeep(FromFieldData),
      columnAllData: TableField,

      activeId: 0,
      activeRow: null,
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        businessNo: undefined,
        businessName: undefined,
        businessBrand: undefined,
        businessModel: undefined,
        businessSerial: undefined,
        outsourceCompany: undefined,
        salesManId: undefined,
        status: 0,
        startTime: '',
        endTime: '',
        payStartTime: '',
        payEndTime: '',
        time: [],
        payTime: [],
        ...pageVo
      },
      pageSizes,
      dialogFormVisible: false,

      salesManOption: [],
      ReviewStatusOption: [],
      UserPayTypeOption: [],
      submitLoading: false,
      accountOption: [],
      selectionArray: [],
      selectionRowList: [],
      formData: {
        paymentAccountId: '',
        paymentTime: '',
        paymentMark: ''
      },
      rules: {
        paymentAccountId: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        paymentTime: [{ required: true, message: '请填写必填项', trigger: 'change' }]
      },
      statusOption: [
        {
          id: 0,
          name: '未付款'
        }, {
          id: 1,
          name: '已付款'
        }
      ],
      handleCommand(command: string, val?: any) {
        switch (command) {
          case 'PAYOK':
          case 'batch-payOk':
            dataMap.activeRow = val
            dataMap.formData = {
              paymentAccountId: '',
              paymentTime: Today,
              paymentMark: ''
            }
            // dataMap.activeId = val.id
            dataMap.selectionRowList = val ? [val] : dataMap.selectionArray

            if (!dataMap.selectionRowList.length) {
              return ElMessage.error({
                message: '请选择数据',
                duration: 1000
              })
            }
            getUrlList('paymentAccount/dropdown').then((res: any) => {
              dataMap.accountOption = res || []
              dataMap.dialogFormVisible = true
            })
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableDataRef.value as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'selection':
            dataMap.selectionArray = val
            break
        }
      },
      getList() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }
        dataMap.listLoading = true
        getPageList('businessMarketFee', { ...dataMap.listQuery, feeType: 2, pageType: 2 }).then((res: any) => {
          dataMap.list = res.data
            ? res.data.map((item: any) => {
              return {
                ...item,
                customerCompany: item.business.customerCompany,
                ticketCompany: item.business.ticketCompany,
                businessNo: item.business.no,
                businessName: item.business.name,
                businessBrand: item.business.brand,
                businessAmount: item.business.amount,
                businessModel: item.business.model,
                businessSerial: item.business.serial,
                businessUnit: item.business.unit,
                businessSalesMan: item.business.salesMan,
                accountAlias: item.account?.alias,
                amount: item.business.amount,
                orderTaxRate: item.business.orderTaxRate,
                orderFee: item.business.orderFee
              }
            })
            : []
          dataMap.total = res.total
          dataMap.listLoading = false
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          businessNo: undefined,
          businessName: undefined,
          businessBrand: undefined,
          businessModel: undefined,
          businessSerial: undefined,
          outsourceCompany: undefined,
          salesManId: undefined,
          status: 0,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          payStartTime: defaultDate[0],
          payEndTime: defaultDate[1],
          time: [],
          payTime: [],
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        // const { time = [], payTime = [] } = dataMap.listQuery
        // dataMap.listQuery.startTime = time ? time[0] : ''
        // dataMap.listQuery.endTime = time ? time[1] : ''
        // dataMap.listQuery.payStartTime = payTime ? payTime[0] : ''
        // dataMap.listQuery.payEndTime = payTime ? payTime[1] : ''
        dataMap.getList()
      },

      handlePayOk(row: any) {
        dataMap.activeId = row.id
        dataMap.activeRow = row
        dataMap.dialogFormVisible = true
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },

      handleCancle() {
        dataMap.dialogFormVisible = true
      },
      async handleSubmit() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              await paymentConfirm({ ...dataMap.formData, ids: dataMap.selectionRowList.map((kk: any) => kk.id) })
              dataMap.dialogFormVisible = false
              dataMap.getList()
              ElMessage({
                message: '提交成功',
                type: 'success',
                duration: 1000
              })
            } catch (err: any) {
              console.log(err)
            }
          }
        })
      },
      handleSalesManFocus() {
        getUrlList('user/dropdown/salesman').then((res: any) => {
          dataMap.salesManOption = res || []
        })
      },
      tableRowClassName({ row }: any) {
        // 红色 -- 已审批-待付款 --已收款
        // 蓝色 -- 已审批-待付款 --未收款，部分收款
        // const obj = {
        //   '审批通过-待付款': 'row-red'
        // }
        // 橙色---业务状态【已收款】--invoiceStatus开票状态为【未申请】
        const businessReceivedStatus = {
          '审批通过-待付款': {
            未收款: 'row-blue',
            部分收款: 'row-blue',
            已收款: 'row-red'
          }
        }
        if (row.business?.receivedStatus === '已收款' && row.invoiceStatus === '未申请') {
          return 'row-orange'
        } else if (row.status === '审批通过-待付款' && !row.business?.receivedStatus) {
          return 'row-blue'
        } else {
          return businessReceivedStatus[row.status]
            ? (businessReceivedStatus[row.status][row.business?.receivedStatus] || '')
            : ''
        }
      },
      handleTableSelect(selection: any) {
        console.log(selection, 2222)
        // dataMap.selectBusinessList = selection
      }
    })
    const { mixinData } = mixin(dataMap)
    onMounted(() => {
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      // dataMap.listQuery.payStartTime = defaultDate[0]
      // dataMap.listQuery.payEndTime = defaultDate[1]
      dataMap.getList()
    })
    return { t, ...toRefs(dataMap), ...toRefs(mixinData), tableDataRef, dataForm }
  }
})
</script>
<style  lang="scss" scope>
.statusStyle{
  .status{
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color:#fff;
  }
}
.redStatusStyle{
  .icon-tubiao-40{
    color:#E74228;
  }
  .status{
    background-color:#E74228;
  }
}
.yellowStatusStyle{
  .icon-tubiao-40{
    color:#F3D03C;
  }
  .status{
    background-color:#F3D03C;
  }
}
</style>
